export enum HeapBulkSelectCheckBoxStatus {
  Checked = 'checked',
  Indeterminate = 'indeterminate',
  Unchecked = 'unchecked',
}

export enum HeapCalculationStatusMessage {
  Failed = 'Calculation Failed',
  Incomplete = 'Calculation Incomplete',
}